export const newPostAction = "lab";
export const newYammerPostAction = "mab";
export default {newPostAction,newYammerPostAction};